import { colors } from '../foundation';

type Props = {
  color?:
    | typeof colors.primary.red
    | (typeof colors.black)[75]
    | (typeof colors.neutral)[10]
    | typeof colors.primary.white;
};

const ArrowLeft = ({ color = colors.primary.red }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M6.4697 8.60224C6.3291 8.70777 6.25 8.85079 6.25 8.99997C6.25 9.14922 6.3291 9.29224 6.4697 9.39777L10.4697 12.3978C10.7626 12.6174 11.2375 12.6174 11.5304 12.3978C11.8233 12.1781 11.8233 11.8219 11.5304 11.6022L8.0607 8.99997L11.5304 6.39775C11.8233 6.17808 11.8233 5.82193 11.5304 5.60225C11.2375 5.38258 10.7626 5.38258 10.4697 5.60225L6.4697 8.60224Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowLeft;
